var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCasosExito(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 171",
    style: {
      enableBackground: "new 0 0 500 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.3,52.2c0-17.9,13.8-30.8,32.3-30.8c10.3,0,18.9,3.7,24.5,10.5l-8.8,8.2c-4-4.6-9-7-15-7 c-11.1,0-19,7.8-19,19c0,11.2,7.9,19,19,19c6,0,11-2.4,15-7.1l8.8,8.2C54.5,79.3,45.9,83,35.5,83C17.1,83,3.3,70.2,3.3,52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.5,55.9V82H96.1v-5.7c-2.5,4.2-7.2,6.4-13.9,6.4c-10.7,0-17.1-6-17.1-13.9c0-8.1,5.7-13.7,19.6-13.7h10.5 c0-5.7-3.4-9-10.5-9c-4.8,0-9.9,1.6-13.2,4.3l-4.8-9.3c5-3.6,12.4-5.5,19.7-5.5C100.5,35.6,108.5,42,108.5,55.9z M95.3,67.5v-4.7 h-9.1c-6.2,0-8.2,2.3-8.2,5.4c0,3.3,2.8,5.5,7.5,5.5C89.9,73.8,93.8,71.7,95.3,67.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.1,77.7l4.4-9.5c4.1,2.6,10.3,4.4,15.9,4.4c6.1,0,8.4-1.6,8.4-4.2c0-7.5-27.6,0.2-27.6-18.1 c0-8.7,7.8-14.8,21.2-14.8c6.3,0,13.3,1.4,17.6,4l-4.4,9.4c-4.5-2.6-9-3.4-13.2-3.4c-6,0-8.5,1.9-8.5,4.2c0,7.8,27.6,0.3,27.6,18.3 c0,8.5-7.9,14.5-21.6,14.5C128.2,82.7,120.4,80.6,116.1,77.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.3,59.1c0-13.8,10.6-23.5,25.2-23.5s25.1,9.8,25.1,23.5c0,13.8-10.5,23.5-25.1,23.5S162.3,72.9,162.3,59.1 z M199.1,59.1c0-7.9-5-12.7-11.6-12.7c-6.6,0-11.7,4.8-11.7,12.7c0,7.9,5.1,12.7,11.7,12.7C194.1,71.8,199.1,67,199.1,59.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.9,77.7l4.4-9.5c4.1,2.6,10.3,4.4,15.9,4.4c6.1,0,8.4-1.6,8.4-4.2c0-7.5-27.6,0.2-27.6-18.1 c0-8.7,7.8-14.8,21.2-14.8c6.3,0,13.3,1.4,17.6,4l-4.4,9.4c-4.5-2.6-9-3.4-13.2-3.4c-6,0-8.5,1.9-8.5,4.2c0,7.8,27.6,0.3,27.6,18.3 c0,8.5-7.9,14.5-21.6,14.5C229,82.7,221.2,80.6,216.9,77.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201.7,86.9L189.1,150h-5.8l1.4-7.1c-4.3,4.7-10.2,7.5-17.4,7.5c-11.5,0-19.5-7.1-19.5-19 c0-15.3,10.7-26.5,25.2-26.5c8.5,0,14.4,3.5,17,9.7l5.5-27.7H201.7z M188,124.2c0-8.8-5.4-13.9-14.7-13.9c-11.1,0-19.4,8.8-19.4,21 c0,8.8,5.4,13.9,14.7,13.9C179.8,145.1,188,136.3,188,124.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.6,129.3c-0.1,0.6-0.1,1.2-0.1,1.8c0,8.9,5.1,13.9,15.4,13.9c6,0,11.3-2.1,14.6-5.6l2.7,4.3 c-4.2,4.2-10.9,6.6-17.9,6.6c-12.9,0-20.8-7.3-20.8-19c0-15.2,10.5-26.4,24.7-26.4c11.8,0,19.5,7.1,19.5,19c0,1.9-0.3,3.7-0.6,5.4 H211.6z M212.2,124.8H244c0.1-0.6,0.1-1.1,0.1-1.6c0-8.5-5.7-13.2-14-13.2C221.1,110,214.4,115.9,212.2,124.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.7,138.9V150h-46.1V90.5h45v11.1h-31.3v12.9h27.6v10.7h-27.6v13.8H328.7z M307.8,85.7h-10.4l11.5-12.2 h14.3L307.8,85.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.2,150l-10-14l-10.4,14h-14.5l17.6-23l-17-22.7h14.9l9.7,13.3l9.9-13.3h14.1l-17,22.4l17.7,23.4H367.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387.1,90.5c0-4.2,3.3-7.4,8.2-7.4c4.9,0,8.2,3.1,8.2,7.1c0,4.4-3.3,7.7-8.2,7.7 C390.4,97.9,387.1,94.7,387.1,90.5z M388.7,104.3H402V150h-13.3V104.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.8,147.8c-2.7,2-6.7,2.9-10.8,2.9c-10.8,0-17.1-5.5-17.1-16.4v-18.8h-7.1v-10.2h7.1V94.2h13.3v11.1h11.4 v10.2h-11.4v18.6c0,3.9,2.1,6,5.7,6c2,0,3.9-0.6,5.4-1.7L443.8,147.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M446.4,127.1c0-13.8,10.6-23.5,25.2-23.5s25.1,9.8,25.1,23.5c0,13.8-10.5,23.5-25.1,23.5 S446.4,140.9,446.4,127.1z M483.2,127.1c0-7.9-5-12.7-11.6-12.7s-11.7,4.8-11.7,12.7c0,7.9,5.1,12.7,11.7,12.7 S483.2,135,483.2,127.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasosExito);
export default __webpack_public_path__ + "static/media/casos_exito.773afd1b3904f15e82cdbed42b1ebe92.svg";
export { ForwardRef as ReactComponent };